"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M5 6H11V5H5V6ZM5 8H11V7H5V8ZM5 10H11V9H5V10ZM14 4V11C14 12.104 13.104 13 12 13H7.207C7.074 13 6.947 13.052 6.854 13.146L4.854 15.146C4.752 15.248 4.627 15.294 4.504 15.294C4.246 15.294 4 15.093 4 14.793V13C2.896 13 2 12.104 2 11V4C2 2.895 2.896 2 4 2H12C13.104 2 14 2.895 14 4ZM16 4.9996C17.104 4.9996 18 5.8956 18 6.9996V13.9996C18 15.0256 17.227 15.8716 16.231 15.9856C16.102 16.0016 16 16.1006 16 16.2296V17.2946C16 17.9256 15.233 18.2376 14.792 17.7866L13.191 16.1496C13.097 16.0546 12.968 15.9996 12.833 15.9996H8C7.298 15.9996 6.683 15.6366 6.325 15.0886L7.414 13.9996H12C13.657 13.9996 15 12.6566 15 10.9996V4.9996H16Z",
    fill: "#727B7F"
  }));
};